import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { image1 } from "../../../assets";
import { Link } from "react-router-dom";
import Carousel from "better-react-carousel";
import { paketWisata } from "../../../store/paketWisata";
import { animateScroll as scroll } from 'react-scroll';

const Card = ({ judul, content, id, image, onClick }) => (
    <Link to={`/paket/${id}`} key={id} onClick={onClick}>
        <div className="w-full mx-4 h-96 rounded-3xl text-white hover:scale-125 transition-all delay-200" style={{ backgroundImage: `url(${image})`, backgroundSize: 'cover', backgroundPosition: 'center center' }}>
            <div className="flex bg-black bg-opacity-20 rounded-3xl flex-col justify-end p-12 content-end h-full">
                <div className="hover:bg-white py-1 px-2 hover:bg-opacity-10 hover:backdrop-blur-sm hover:rounded-lg transition delay-100">
                    <h1 className="text-2xl font-bold mb-4">{judul}</h1>
                    <div className="flex justify-center">
                        <h3 className="w-3/4">{content}</h3>
                    </div>
                </div>
            </div>
        </div>
    </Link>
)



const PaketWisata = () => {

    const scrollToTop = () => {
        scroll.scrollToTop();
    }

    return (
        <div className="flex justify-center px-4 pt-16 lg:pt-28 py-12" id="paket-wisata">
            <div className="container">
                <div className="text-center" data-aos="zoom-in-up">
                    <h1 className="text-4xl py-4 text-green-600 font-header">Apa yang kami sediakan ?</h1>
                    <h3 className="text-xl py-2">Paket Ekowisata yang Tersedia </h3>
                    <p className="text-xl">Mari lakukan penjelajahan bersama kami di Pulau Gili Iyang maka anda akan mendapatkan berbagai hal menarik</p>
                </div>
                <div className="py-12" data-aos="zoom-in-down">
                    <Carousel cols={2} rows={1} gap={44} loop autoPlay scrollSnap="true" >
                        {
                            paketWisata.map((paket) => {
                                return (
                                    <Carousel.Item className="" key={paket.id}>
                                        <Card
                                            judul={paket.namePaket}
                                            content={paket.content}
                                            key={paket.id}
                                            id={paket.id}
                                            image={paket.image_path}
                                            onClick={scrollToTop}
                                        />
                                    </Carousel.Item>
                                )
                            })
                        }

                    </Carousel>

                    {/* <Carousel axis="horizontal"
                        infiniteLoop={true}
                        autoPlay={true}
                        // showIndicators={true}
                        // showThumbs={false}
                        width='100%'
                        transitionTime={2000}
                        showArrows={true}
                        swipeable={true}
                        thumbWidth={100}
                        // emulateTouch={true}
                        // centerMode={true}
                        onClickItem={() => { }}
                        // onClickThumb={true}
                        // centerSlidePercentage={85}
                        className="">
                        <Link className="">
                            <div className="w-1/3 py-12 bg-black">
                                <div className="">
                                    <h1>Ekowisata 1</h1>
                                    <p>Mari lakukan penjelajahan bersama kami di Pulau Gili Iyang maka anda akan mendapatkan berbagai hal menarik</p>
                                    <a href="" className="flex pr-2 flex justify-center">
                                        <p className="my-auto">more</p>
                                        <FontAwesomeIcon className="text-lg w-8 my-auto" icon={faArrowRight} />
                                    </a>
                                </div>
                            </div>
                        </Link>
                    </Carousel> */}
                </div>
            </div>
        </div>
    )
}

export default PaketWisata;